import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, FileText, CheckSquare, Bell, User } from 'lucide-react';

const TABS = [
  { path: '/', icon: Home, labelKey: 'common.home' },
  { path: '/timesheets', icon: FileText, labelKey: 'common.timesheets' },
  { path: '/approvals', icon: CheckSquare, labelKey: 'common.approvals' },
  { path: '/notifications', icon: Bell, labelKey: 'common.alerts' },
  { path: '/leave', icon: User, labelKey: 'common.leave' },
];

export default function MobileNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <nav className="fixed bottom-0 start-0 end-0 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 z-40 sm:hidden safe-area-bottom">
      <div className="flex justify-around items-center h-14">
        {TABS.map(tab => {
          const active = location.pathname === tab.path.split('?')[0];
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center gap-0.5 px-3 py-1.5 transition-colors ${
                active ? 'text-blue-400' : 'text-slate-600 dark:text-slate-500'
              }`}
            >
              <tab.icon className="w-5 h-5" />
              <span className="text-[10px] font-medium">{t(tab.labelKey)}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
